import { render, staticRenderFns } from "./ReleaseOrders.vue?vue&type=template&id=253da204"
import script from "./ReleaseOrders.vue?vue&type=script&lang=js"
export * from "./ReleaseOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports